/**
 * Max spots per member (ISSUE-1287, ISSUE-1294): 1 to 5 or Unlimited,
 * counted per strip. One field for the create step and Settings, so both
 * offer the same choices with the same words. The choices are the engine's
 * own list; the server validates the value again on save.
 */
import { STRIP_MAX_SPOTS_CHOICES } from "@sportsmet/contest-engine";
import { Radio } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  STRIP_MAX_SPOTS_LABEL,
  stripMaxSpotsChoiceLabel,
} from "./stripCardCopy";

const UNLIMITED = "unlimited";

export function maxSpotsToFieldValue(value: number | null): string {
  return value === null ? UNLIMITED : String(value);
}

export function maxSpotsFromFieldValue(value: string): number | null {
  if (value === UNLIMITED) return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) ? parsed : null;
}

export const StripMaxSpotsField = (props: {
  value: number | null;
  onChange: (next: number | null) => void;
  disabled?: boolean;
}): ReactNode => (
  <Radio
    label={STRIP_MAX_SPOTS_LABEL}
    value={maxSpotsToFieldValue(props.value)}
    disabled={props.disabled}
    onValueChange={(next) => {
      props.onChange(maxSpotsFromFieldValue(next));
    }}
    items={[
      ...STRIP_MAX_SPOTS_CHOICES.map((choice) => ({
        value: String(choice),
        label: stripMaxSpotsChoiceLabel(choice),
      })),
      { value: UNLIMITED, label: stripMaxSpotsChoiceLabel(null) },
    ]}
  />
);
